<template>
  <div>
    <div class="ai_sidebar">
      <div class="ai_sidebar_auto">
        <slot name="content"></slot>
        <div class="ai_sidebar_">
          <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
          <div class="ai_sidebar_img">
            <img
              src="../../assets/img/GPTSoul.svg"
              alt="asd"
              class="ai_chat_img"
            />
          </div>
          <div
            class="ai_sidebar__desc"
            v-if="
              $route.path !== '/user/chatbots' &&
              $route.path !== '/user/create_bot' &&
              $route.path !== '/user/bot_settings'
            "
          >
            <slot>
              <sidebar-link
                v-for="(link, index) in sidebarLinks"
                :key="link.name + index"
                :to="link.path"
                @click="closeNavbar"
                :link="link"
              >
                <i :class="link.icon"></i>
                <p>{{ link.name }}</p>
              </sidebar-link>
            </slot>
          </div>
        </div>
        <ul class="nav nav-bottom" v-if="$slots['bottom-links']">
          <slot name="bottom-links"></slot>
        </ul>
      </div>
      <div class="help_support">
        <span class="help_support_text"> Help and Support </span>
        <span class="feebback"> Feedback </span>
        <span class="help"> Help center </span>
      </div>
    </div>
  </div>
</template>
<script>
import SidebarLink from "./SidebarLink.vue";

export default {
  components: {
    SidebarLink,
  },
  props: {
    title: {
      type: String,
      default: "CHATBOT AI",
    },
    backgroundColor: {
      type: String,
      default: "black",
      validator: (value) => {
        let acceptedValues = [
          "",
          "blue",
          "azure",
          "green",
          "orange",
          "red",
          "purple",
          "black",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    activeColor: {
      type: String,
      default: "success",
      validator: (value) => {
        let acceptedValues = [
          "primary",
          "info",
          "success",
          "warning",
          "danger",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`,
      };
    },
  },
};
</script>
<style>
.ai_sidebar {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #f8f9fa;
}
.ai_chat_img {
  padding: 40px 0 35px 40px;
}
.ai_sidebar_ {
  height: 100%;
}
.ai_sidebar__desc {
  padding-top: 100px;
  max-width: 280px;
  width: 100%;
}
.side_img {
  width: 100% !important;
}
.ai_sidebar_img {
  position: absolute;
  background: #f8f9fa;
  width: 100%;
}
.ai_sidebar_auto {
  height: calc(100% - 200px);
  overflow: auto;
}
.help_support {
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 22px;
  margin-left: 40px;
  width: 100%;
  max-width: 200px;
  padding-bottom: 40px;
  padding-top: 22px;
  border-top: 1px solid #e7e7e7;
}
.help_support_text {
  color: #637381;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  cursor: pointer;
}
.help_support .feebback,
.help_support .help {
  color: #637381;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  cursor: pointer;
}
.hidden {
  /* display: none; */
}
@media screen and (max-width: 992px) {
  .ai_chat_img {
    padding-top: 20px;
  }
}
</style>
